// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.EbooksHome_outerContainer__oQUTn {
  background-color: #1A1A1A;
  width: 100%;
}

.EbooksHome_container__Zj2hR {
  color: white;
  background-color: #1A1A1A;
  width: 100%;
  max-width: 95%;
  margin: 0 auto;
  transform: translateZ(0);
}

.EbooksHome_header__rCgbR {
  display: flex;
  align-items: center;
  gap: 30px;
  margin-bottom: 10px;
  max-width: 100%;
  margin-left: auto;
  margin-right: auto;
  position: relative;
  padding: 0;
}

.EbooksHome_title__JWYJO {
  font-size: 20px;
  font-weight: bold;
  margin: 0;
  white-space: nowrap;
}

.EbooksHome_languageButtons__J2MvU {
  display: flex;
  gap: 15px;
  flex-wrap: nowrap;
  overflow-x: auto;
  scrollbar-width: none;
  -ms-overflow-style: none;
  padding: 5px 0;
}

.EbooksHome_languageButtons__J2MvU::-webkit-scrollbar {
  display: none;
}

.EbooksHome_swiperContainer__UGN9u {
  max-width: 100%;
  margin: 0 auto;
  position: relative;
  background-color: #1A1A1A;
}

.EbooksHome_swiperWrapper__0bpu4 {
  background-color: #1A1A1A;
  width: 100%;
  overflow: visible;
  transform: translateZ(0);
}

.EbooksHome_swiperCard__vIWGw {
  width: 100%;
  height: 100%;
  background-color: #1A1A1A !important;
  transform: translateZ(0);
  z-index: 1;
}

.EbooksHome_customSlide__3CiYf {
  background-color: #1A1A1A;
  transform: translateZ(0);
  backface-visibility: hidden;
}

.EbooksHome_languageButton__jlZAi {
  padding: 8px 20px;
  border: none;
  font-weight: 600;
  background: transparent;
  color: white;
  cursor: pointer;
  border-radius: 25px;
  font-size: 14px;
  white-space: nowrap;
  transition: background-color 0.3s ease;
}

.EbooksHome_languageButton__jlZAi:hover {
  background: rgba(255, 0, 0, 0.2);
}

.EbooksHome_languageButton__jlZAi.EbooksHome_active__9E5wS {
  background: #ff0000;
}

.EbooksHome_navigation__5\\+cWX {
  display: flex;
  gap: 10px;
  margin-left: auto;
}

.EbooksHome_navButton__hNlII {
  background: transparent;
  border: 1px solid rgba(255, 255, 255, 0.25);
  border-radius: 50%;
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  color: white;
  transition: all 0.3s ease;
  padding: 0;
}

.EbooksHome_navButton__hNlII:hover {
  background: rgba(255, 255, 255, 0.1);
  border-color: rgba(255, 255, 255, 0.4);
}

.EbooksHome_navButton__hNlII:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.EbooksHome_noBooks__Jgjiy {
  color: white;
  padding: 20px;
  text-align: center;
  background-color: #1A1A1A;
}

.EbooksHome_loading__Y89kc {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 200px;
  background-color: #1A1A1A;
}

@media (max-width: 1024px) {
  .EbooksHome_header__rCgbR {
    gap: 20px;
  }
}

@media (max-width: 768px) {
  .EbooksHome_header__rCgbR {
    flex-wrap: wrap;
    gap: 15px;
  }
  
  .EbooksHome_title__JWYJO {
    font-size: 24px;
  }
  
  .EbooksHome_languageButtons__J2MvU {
    order: 2;
    width: 100%;
    justify-content: flex-start;
  }
  
  .EbooksHome_navigation__5\\+cWX {
    margin-left: auto;
  }
}

@media (max-width: 480px) {
  .EbooksHome_header__rCgbR {
    gap: 10px;
  }
  .EbooksHome_container__Zj2hR{
    width: 100%;
    margin: 0 auto;
  }
  
  .EbooksHome_navigation__5\\+cWX {
    position: absolute;
    top: 105%;
    right: 10px;
    transform: translateY(-50%);
  }
  .EbooksHome_title__JWYJO{
    font-size: 18px;
  }
  
  .EbooksHome_navButton__hNlII {
    width: 32px;
    height: 32px;
  }
}`, "",{"version":3,"sources":["webpack://./src/Homepage/components/Css/EbooksHome.module.css"],"names":[],"mappings":"AAAA;EACE,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,yBAAyB;EACzB,WAAW;EACX,cAAc;EACd,cAAc;EAEd,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,mBAAmB;EACnB,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,iBAAiB;EACjB,gBAAgB;EAChB,qBAAqB;EACrB,wBAAwB;EACxB,cAAc;AAChB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,eAAe;EACf,cAAc;EACd,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,WAAW;EACX,iBAAiB;EAEjB,wBAAwB;AAC1B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,oCAAoC;EAEpC,wBAAwB;EACxB,UAAU;AACZ;;AAEA;EACE,yBAAyB;EAEzB,wBAAwB;EACxB,2BAA2B;AAC7B;;AAEA;EACE,iBAAiB;EACjB,YAAY;EACZ,gBAAgB;EAChB,uBAAuB;EACvB,YAAY;EACZ,eAAe;EACf,mBAAmB;EACnB,eAAe;EACf,mBAAmB;EACnB,sCAAsC;AACxC;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,iBAAiB;AACnB;;AAEA;EACE,uBAAuB;EACvB,2CAA2C;EAC3C,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,YAAY;EACZ,yBAAyB;EACzB,UAAU;AACZ;;AAEA;EACE,oCAAoC;EACpC,sCAAsC;AACxC;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;EACb,yBAAyB;AAC3B;;AAEA;EACE;IACE,SAAS;EACX;AACF;;AAEA;EACE;IACE,eAAe;IACf,SAAS;EACX;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,QAAQ;IACR,WAAW;IACX,2BAA2B;EAC7B;;EAEA;IACE,iBAAiB;EACnB;AACF;;AAEA;EACE;IACE,SAAS;EACX;EACA;IACE,WAAW;IACX,cAAc;EAChB;;EAEA;IACE,kBAAkB;IAClB,SAAS;IACT,WAAW;IACX,2BAA2B;EAC7B;EACA;IACE,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,YAAY;EACd;AACF","sourcesContent":[".outerContainer {\n  background-color: #1A1A1A;\n  width: 100%;\n}\n\n.container {\n  color: white;\n  background-color: #1A1A1A;\n  width: 100%;\n  max-width: 95%;\n  margin: 0 auto;\n  -webkit-transform: translateZ(0);\n  transform: translateZ(0);\n}\n\n.header {\n  display: flex;\n  align-items: center;\n  gap: 30px;\n  margin-bottom: 10px;\n  max-width: 100%;\n  margin-left: auto;\n  margin-right: auto;\n  position: relative;\n  padding: 0;\n}\n\n.title {\n  font-size: 20px;\n  font-weight: bold;\n  margin: 0;\n  white-space: nowrap;\n}\n\n.languageButtons {\n  display: flex;\n  gap: 15px;\n  flex-wrap: nowrap;\n  overflow-x: auto;\n  scrollbar-width: none;\n  -ms-overflow-style: none;\n  padding: 5px 0;\n}\n\n.languageButtons::-webkit-scrollbar {\n  display: none;\n}\n\n.swiperContainer {\n  max-width: 100%;\n  margin: 0 auto;\n  position: relative;\n  background-color: #1A1A1A;\n}\n\n.swiperWrapper {\n  background-color: #1A1A1A;\n  width: 100%;\n  overflow: visible;\n  -webkit-transform: translateZ(0);\n  transform: translateZ(0);\n}\n\n.swiperCard {\n  width: 100%;\n  height: 100%;\n  background-color: #1A1A1A !important;\n  -webkit-transform: translateZ(0);\n  transform: translateZ(0);\n  z-index: 1;\n}\n\n.customSlide {\n  background-color: #1A1A1A;\n  -webkit-transform: translateZ(0);\n  transform: translateZ(0);\n  backface-visibility: hidden;\n}\n\n.languageButton {\n  padding: 8px 20px;\n  border: none;\n  font-weight: 600;\n  background: transparent;\n  color: white;\n  cursor: pointer;\n  border-radius: 25px;\n  font-size: 14px;\n  white-space: nowrap;\n  transition: background-color 0.3s ease;\n}\n\n.languageButton:hover {\n  background: rgba(255, 0, 0, 0.2);\n}\n\n.languageButton.active {\n  background: #ff0000;\n}\n\n.navigation {\n  display: flex;\n  gap: 10px;\n  margin-left: auto;\n}\n\n.navButton {\n  background: transparent;\n  border: 1px solid rgba(255, 255, 255, 0.25);\n  border-radius: 50%;\n  width: 40px;\n  height: 40px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  color: white;\n  transition: all 0.3s ease;\n  padding: 0;\n}\n\n.navButton:hover {\n  background: rgba(255, 255, 255, 0.1);\n  border-color: rgba(255, 255, 255, 0.4);\n}\n\n.navButton:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n.noBooks {\n  color: white;\n  padding: 20px;\n  text-align: center;\n  background-color: #1A1A1A;\n}\n\n.loading {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  height: 200px;\n  background-color: #1A1A1A;\n}\n\n@media (max-width: 1024px) {\n  .header {\n    gap: 20px;\n  }\n}\n\n@media (max-width: 768px) {\n  .header {\n    flex-wrap: wrap;\n    gap: 15px;\n  }\n  \n  .title {\n    font-size: 24px;\n  }\n  \n  .languageButtons {\n    order: 2;\n    width: 100%;\n    justify-content: flex-start;\n  }\n  \n  .navigation {\n    margin-left: auto;\n  }\n}\n\n@media (max-width: 480px) {\n  .header {\n    gap: 10px;\n  }\n  .container{\n    width: 100%;\n    margin: 0 auto;\n  }\n  \n  .navigation {\n    position: absolute;\n    top: 105%;\n    right: 10px;\n    transform: translateY(-50%);\n  }\n  .title{\n    font-size: 18px;\n  }\n  \n  .navButton {\n    width: 32px;\n    height: 32px;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"outerContainer": `EbooksHome_outerContainer__oQUTn`,
	"container": `EbooksHome_container__Zj2hR`,
	"header": `EbooksHome_header__rCgbR`,
	"title": `EbooksHome_title__JWYJO`,
	"languageButtons": `EbooksHome_languageButtons__J2MvU`,
	"swiperContainer": `EbooksHome_swiperContainer__UGN9u`,
	"swiperWrapper": `EbooksHome_swiperWrapper__0bpu4`,
	"swiperCard": `EbooksHome_swiperCard__vIWGw`,
	"customSlide": `EbooksHome_customSlide__3CiYf`,
	"languageButton": `EbooksHome_languageButton__jlZAi`,
	"active": `EbooksHome_active__9E5wS`,
	"navigation": `EbooksHome_navigation__5+cWX`,
	"navButton": `EbooksHome_navButton__hNlII`,
	"noBooks": `EbooksHome_noBooks__Jgjiy`,
	"loading": `EbooksHome_loading__Y89kc`
};
export default ___CSS_LOADER_EXPORT___;
